interface ILoginTitleProps {
  title: string;
  subtitle?: string;
}

const LoginTitle = ({ title, subtitle }: ILoginTitleProps) => {
  return (
    <div className="flex w-full flex-col items-center gap-2 pb-6 pt-4">
      <span className="text-primary text-display-sm font-semibold tracking-tight">{title}</span>
      {subtitle && <span className="text-secondary text-md text-center">{subtitle}</span>}
    </div>
  );
};

LoginTitle.displayName = 'LoginTitle';

export default LoginTitle;
